/* TT2 homepage reveals — IntersectionObserver, unobserve after fire.
   Guarded so repeated script tags (one per section) init exactly once. */
(function () {
  if (window.__tt2Init) return;
  window.__tt2Init = true;
  function init() {
    var els = document.querySelectorAll('.tt2-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('tt2-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('tt2-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
